import { escapeRegExp } from "lodash";
var underline = function (value, search) {
    if (search && value) {
        var escaped = escapeRegExp(search);
        var reg = new RegExp("(".concat(escaped, ")"), 'i');
        return value === null || value === void 0 ? void 0 : value.replace(reg, '<em>$1</em>');
    }
    else {
        return value;
    }
};
export default underline;
